const svgConfig = require('../../../json/svg.json');

export const svgService = (() => {

    // SVG function (get svg from svg.json file and att it to element with class svg and with data attr svg-path)
    $( '.svg' ).each( function() {
		let svgPathName = $(this).data( 'svg-path' );
		$(this).html( svgConfig.svg[ svgPathName ] );
	});

})();



// WEBPACK FOOTER //
// ./src/assets/scripts/service/svg-service.js